import { Api, Config } from './api'

export const ApiObterGrupoUsuario = async (filtros) => {
   const params = new URLSearchParams()

   if (filtros.ordenar) {
      params.append('ordenar', filtros.ordenar)
   }

   if (filtros.descricao) {
      params.append('descricao', filtros.descricao)
   }

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }

   const { data } = await Api.get(`/grupo-usuario`, Config(params))

   return data
}
export const ApiObterGrupoUsuarioPorId = async (id) => {
   const { data } = await Api.get(`/grupo-usuario/${id}`, Config())

   return data
}

export const ApiSalvarGrupoUsuario = async (grupo) => {
   if (grupo.id) {
      const { data } = await Api.put(`/grupo-usuario/${grupo.id}`, grupo, Config())
      return data
   } else {
      const { data } = await Api.post(`/grupo-usuario`, grupo, Config())
      return data
   }
}
export const ApiInativarGrupoUsuario = async (id) => {
   const { data } = await Api.put(`/grupo-usuario/${id}/inativar`, Config())
   return data
}
